import { useState, useCallback } from 'react';
import { useAuth } from '../AuthContext';

interface UsePointsCheckReturn {
  checkPoints: (requiredPoints: number) => boolean;
  showDialog: boolean;
  dialogProps: {
    userPoints: number;
    requiredPoints: number;
    isZeroPoints: boolean;
  };
  closeDialog: () => void;
}

export const usePointsCheck = (): UsePointsCheckReturn => {
  const { user } = useAuth();
  const [showDialog, setShowDialog] = useState(false);
  const [dialogProps, setDialogProps] = useState({
    userPoints: 0,
    requiredPoints: 0,
    isZeroPoints: false,
  });

  const checkPoints = useCallback(
    (requiredPoints: number): boolean => {
      const userPoints = user?.points || 0;

      console.log('[积分检查]', {
        userPoints,
        requiredPoints,
        user,
        hasUser: !!user,
        willShowDialog: userPoints < requiredPoints
      });

      // 积分为0时，显示特殊弹窗
      if (userPoints === 0) {
        console.log('[积分检查] 显示积分为0弹窗');
        setDialogProps({
          userPoints: 0,
          requiredPoints,
          isZeroPoints: true,
        });
        setShowDialog(true);
        return false;
      }

      // 积分不足但不为0时，显示普通提醒
      if (userPoints < requiredPoints) {
        console.log('[积分检查] 显示积分不足弹窗');
        setDialogProps({
          userPoints,
          requiredPoints,
          isZeroPoints: false,
        });
        setShowDialog(true);
        return false;
      }

      console.log('[积分检查] 积分充足，继续操作');
      return true;
    },
    [user]
  );

  const closeDialog = useCallback(() => {
    setShowDialog(false);
  }, []);

  return {
    checkPoints,
    showDialog,
    dialogProps,
    closeDialog,
  };
};
